<template>
  <div>
    <v-layout wrap>
      <v-flex xs12 sm8>
        <div v-if="isWaitingApproval || isApprover" class="mb-1">
          <v-chip :color="statusColor" text-color="white" small disabled>{{ statusName }}</v-chip>
          <span v-if="broadcast.status === 'disapproval'" class="error--text body2">
            เนื่องจาก {{ broadcast.approval_reason }}
          </span>
        </div>
        <div class="caption">{{ $t('broadcast_id') }}: {{ broadcast.id }}</div>
        <p class="text-truncate">{{ broadcast.name }}</p>
      </v-flex>
      <v-flex xs12 sm4 text-xs-right>
        <v-btn
          v-if="showEditButton"
          fab
          outline
          class="extra-small ma-1"
          color="primary"
          @click="$emit('editBroadcast', broadcast, isSaveOnly)"
        >
          <em class="fas fa-pencil-alt" />
        </v-btn>
        <v-btn
          v-if="!isWaitingApproval && !isApprover"
          fab
          outline
          class="extra-small ma-1"
          color="primary"
          @click="$emit('copyBroadcast', broadcast, draft ? 'draft' : 'sent')"
        >
          <em class="fas fa-copy" />
        </v-btn>
        <v-btn
          v-if="showDeleteButton"
          fab
          outline
          class="extra-small ma-1"
          color="primary"
          @click="$emit('deleteBroadcast', broadcast.id, broadcast.name, isSaveOnly)"
        >
          <em class="fas fa-trash" />
        </v-btn>
        <v-btn
          v-if="showViewButton"
          fab
          outline
          class="extra-small ma-1"
          color="primary"
          @click="$emit('viewBroadcast', index)"
        >
          <em class="fas fa-eye" />
        </v-btn>
        <v-btn
          v-if="isApprover && broadcast.status === 'waiting'"
          depressed
          color="primary"
          @click="$emit('viewBroadcast', index)"
        >
          ตรวจสอบข้อมูล
        </v-btn>
      </v-flex>
      <v-flex xs12 sm4 class="grey--text text--lighten-1 caption">
        <div>
          {{ broadcast.createdtime | DateFormat('DD/MM/YYYY hh:mm A') }}
        </div>
        <div>{{ $t('Created by') + ' ' }} {{ adminName }}</div>
        <div v-if="broadcast.approved_by">{{ $t('approved_by') }}: {{ broadcast.approved_by }}</div>
      </v-flex>
      <v-flex xs12 sm8 class="text-xs-left text-sm-right">
        <v-chip
          v-if="broadcast.isschedule && !isWaitingApproval"
          color="info"
          text-color="white"
          small
          disabled
        >
          <v-avatar>
            <v-icon>access_time</v-icon>
          </v-avatar>
          {{ broadcast.scheduletime | DateFormat('DD/MM/YYYY hh:mm A') }}
        </v-chip>
        <v-chip
          v-else-if="!isWaitingApproval && draft"
          color="grey"
          text-color="white"
          small
          disabled
          >{{ $t('Draft') }}</v-chip
        >
        <template v-if="!isWaitingApproval">
          <v-chip
            v-if="parseFloat(broadcast.no_reach) > 0"
            color="#A0E83D"
            text-color="white"
            small
            @click="handleShowBroadcastHistory('reach')"
            >{{ $t('Reach') + ' ' + broadcast.no_reach + ' ' + $t('users') }}</v-chip
          >
          <v-chip
            v-if="parseFloat(broadcast.no_unreach) > 0"
            color="red"
            text-color="white"
            small
            @click="handleShowBroadcastHistory('unreach')"
            >{{ $t('Unreach') + ' ' + broadcast.no_unreach + ' ' + $t('users') }}</v-chip
          >
        </template>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import axios from 'axios'
import { mapGetters } from 'vuex'
export default {
  props: ['broadcast', 'index', 'draft', 'isSaveOnly', 'isWaitingApproval', 'isApprover'],
  data() {
    return {
      //   broadcast: this.value,
    }
  },

  computed: {
    ...mapGetters(['selectedBot']),
    adminName() {
      const vm = this
      let result = ''
      if (vm.broadcast.createdby) {
        if (/^\d+$/.test(vm.broadcast.createdby)) {
          const tempResult = vm.$store.state.facebook_users_name.find(
            (el) => el.id == vm.broadcast.createdby
          )
          if (tempResult) {
            result = tempResult.name
          }
        } else {
          result = vm.broadcast.createdby
        }
      }
      return result
    },
    statusColor() {
      const tempStatus = this.broadcast.status
      let color = '#F2B310'
      if (tempStatus === 'timeout') {
        color = '#F26F10'
      } else if (tempStatus === 'disapproval') {
        color = '#DA0E0F'
      } else if (tempStatus === 'sent') {
        color = 'green'
      }
      return color
    },
    statusName() {
      const tempStatus = this.broadcast.status
      let name = 'รออนุมัติ'
      if (tempStatus === 'timeout') {
        name = 'หมดเวลาบรอดแคสต์'
      } else if (tempStatus === 'disapproval') {
        name = 'ไม่อนุมัติ'
      } else if (tempStatus === 'sent') {
        name = 'ส่งแล้ว'
      }

      return name
    },
    showEditButton() {
      let show = true
      if (!this.draft) {
        show = false
      } else if (
        this.isWaitingApproval &&
        this.broadcast.status !== 'disapproval' &&
        this.broadcast.status !== 'timeout'
      ) {
        show = false
      }
      return show
    },
    showDeleteButton() {
      let show = false
      if (this.draft && !this.isWaitingApproval) {
        show = true
      }
      return show
    },
    showViewButton() {
      let show = true
      if (this.broadcast.status === 'draft') {
        show = false
      } else if (this.isApprover && this.broadcast.status === 'waiting') {
        show = false
      }
      return show
    }
  },
  mounted() {
    if (this.broadcast.createdby && /^\d+$/.test(this.broadcast.createdby))
      this.getFbName(this.broadcast.createdby)
  },
  methods: {
    handleShowBroadcastHistory(type) {
      this.$emit('onShowBroadcastHistory', type)
    },
    async getFbName(userid) {
      const vm = this
      const fbusersname = vm.$store.state.facebook_users_name
      if (!fbusersname.some((el) => el.id == userid)) {
        const result = await axios.get(
          `https://graph.facebook.com/${userid}?fields=name&access_token=${vm.selectedBot.page_access_token}`
        )
        if (result) {
          vm.$store.state.facebook_users_name.push(result.data)
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/Aira/Broadcast/BroadcastItem.vue